import { fetchRecentTeamVideosCreator } from '../../../../creators/videosDashboard';
import {
  ADD_VIDEO_TO_TEAM_CARD_KEY,
  CUSTOMIZE_BRANDING_CARD_KEY,
  RECORD_VIDEO_CARD_KEY,
  SHARE_VIDEO_CARD_KEY,
} from '../../../../../../shared/constants/workspaceOnboarding';

/*
  ## Personal Library Onboarding Configuration

  * The `cards` array accepts `{ [CARD_KEY]: CONFIG_OBJECT }` as inputs, as well as arrays of
  `[ { [CARD_KEY1]: {...} }, { [CARD_KEY2]: {...} } ]` in case `type` is set to sequential.

  * Each card has these options available:
    > `dismissable` (Boolean)   // Allow card to be marked as complete and dismissed
    > `filter`      (Function)  // Function to define wheter the card will be displayed or not.
                                // Should return `true` for visible and `false` for hidden.
                                // This only evaluates if the card has not been dismissed yet.
    > `onComplete`  (Function)  // Callback function executed when a card is marked as complete.
    > `onDismiss`   (Function)  // Callback function executed when a card is dismissed.

  * This configuration file does not require the addition of PERSONAL_LIBRARY_INTRO_CARD,
  which is included to the onboarding carousel by default at utilities/getPersonalLibraryCards.
*/
export const getPersonalLibraryCardsConfig = ({
  isAdmin,
  hasSharedVideo,
  hasRecordingExperience,
  userHasVideosInTeamLibrary,
  userCanCustomizeSharePage,
}) => {
  return {
    cards: [
      {
        [RECORD_VIDEO_CARD_KEY]: {
          dismissable: true,
          filter: () => {
            return !hasRecordingExperience;
          },
        },
      },
      {
        [SHARE_VIDEO_CARD_KEY]: {
          dismissable: true,
          filter: () => {
            return !hasSharedVideo;
          },
        },
      },
      {
        [ADD_VIDEO_TO_TEAM_CARD_KEY]: {
          dismissable: true,
          filter: () => {
            return !userHasVideosInTeamLibrary;
          },
          onDismiss: dispatch => {
            dispatch(fetchRecentTeamVideosCreator(true));
          },
        },
      },
      [
        {
          [CUSTOMIZE_BRANDING_CARD_KEY]: {
            dismissable: true,
            filter: () => {
              return isAdmin && hasSharedVideo && userCanCustomizeSharePage;
            },
          },
        },
      ],
    ],
  };
};
